import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';

export default class CategoriesOverlay extends Component {
    constructor(props) {
        super(props);

        this.onClose = this.onClose.bind(this);
    }

    onClick(id) {
        window.overviewActiveSlide = undefined;
        this.props.changeCategory(id);
        this.props.close();
    }

    onClose() {
        this.props.close();
    }

    render() {
        const openedClass = this.props.isOpened ? 'is-opened' : '';
        const currentId = this.props.currentCategory;
        const allCategoriesActiveClass = currentId ? '' : 'is-active';
        return (
            <div className={`${openedClass} categoriesOverlay`}>
                <button className="categoriesOverlay-close" onClick={this.onClose}>
                    <Isvg src="../../svg/cancel.svg" />
                </button>
                <ul>
                    <li
                        className={`${allCategoriesActiveClass} categoriesOverlay-category categoriesOverlay-category--all`}
                        key="0"
                        onClick={() => this.onClick()}
                    >
                        {this.props.allCategoriesName}
                    </li>
                    {this.props.categories.map(category => {
                        const activeClass = category.id === currentId ? 'is-active' : '';

                        return (
                            <li
                                key={category.id}
                                className={`${activeClass} categoriesOverlay-category`}
                                onClick={() => this.onClick(category.id)}
                            >
                                {category.name}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}
